import { createContext, useCallback, useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'
import { useMutation } from '@apollo/client/react'
import { AdminAPI, GraphQL } from '@guestgoodie/graphql'

import { dynamicActivate } from './Provider'
import { defaultLocale, LOCALE, locales } from '../utils/locale'

type ContextState = {
  label: string
  flag: string
  lang: LOCALE
  onChange: (lang: string) => void
}

export const LanguageContext = createContext<ContextState>({
  ...locales[defaultLocale],
  lang: defaultLocale,
  onChange: () => null
})

export function LanguageProvider({ children }: React.PropsWithChildren) {
  const { i18n } = useLingui()

  const lang = useMemo(() => i18n.locale.split('-')[0] as LOCALE, [i18n.locale])
  const [updateUser] = useMutation(AdminAPI.user.UPDATE)

  const onChange = useCallback(
    (lang: string) => {
      updateUser({
        variables: {
          input: { preferedLocale: lang.toUpperCase() as GraphQL.Locale }
        }
      })

      dynamicActivate(lang)
    },
    [updateUser]
  )

  const value = useMemo(() => {
    return {
      ...locales[lang],
      lang,
      onChange
    }
  }, [lang, onChange])

  return <LanguageContext value={value}>{children}</LanguageContext>
}
